
















































































import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import MatchConflictsProductPrincipalAccordionTable from "@/components/Agents/MatchConflictsProductPrincipalAccordionTable.vue";
import AgentsMatchProblemGroupMixin, {
  AgentsMatchProblemGroupMixinTags,
} from "@/mixins/http/Agents/AgentsMatchProblemGroupMixin";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import ToastInvoker from "@/utils/ToastInvoker";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { AgentModuleConfiguration } from "@/models";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import MatchProblemGroup from "@/models/Agents/MatchProblemGroup";
import MatchProblemProduct from "@/models/Agents/MatchProblemProduct";
import { NotificationBadgeGroups } from "@/components/Agents/NotificationBadge.vue";

@Component({
  components: {
    MatchConflictsProductPrincipalAccordionTable,
    MultiLevelSelect,
    LogoWithFallback,
  },
})
export default class MatchConflictsProductSelectPrincipalAccordion extends Mixins(
  AgentsMatchProblemGroupMixin
) {
  @Prop() readonly matchProblemGroup!: MatchProblemGroup;
  @Prop() readonly agentModuleConfiguration!: AgentModuleConfiguration;

  @Getter("profile") readonly profile!: AdcontrolProfile;

  @Action("notificationsGroups/reload")
  readonly reloadNotificationForGroup!: (
    group: NotificationBadgeGroups
  ) => void;

  loading = false;
  state: "opened" | "closed" = "closed";
  selectedProductId: string | null = null;
  selectedCompanyId: string | null = null;
  adcontrolProductName: string = this.matchProblemGroup.adcontrolProductName;
  adcontrolProductId: number = this.matchProblemGroup.adcontrolProductId;
  adcontrolProductCompanyIconUrl: string =
    this.matchProblemGroup.adcontrolCompanyIconUrl;
  matchProblemProducts: MatchProblemProduct[] = [];
  options: any[] = [];
  resolved = false;
  multipleProductsPresent = false;

  @Watch("selectedProductId")
  onProductIdChanged(value: number) {
    const selectedProduct = this.matchProblemProducts.find(
      (product) => product.id === value
    );

    if (!selectedProduct) return;

    this.selectedCompanyId = selectedProduct.agentCompanyId;
  }

  async onMultipleProductSolved() {
    await this.loadMatchProblemsGroupProducts();
  }

  async toggleState() {
    if (this.isResolved()) return;

    if (this.state == "opened" && !this.isResolved()) {
      this.state = "closed";
      this.multipleProductsPresent = false;
      return;
    }

    this.state = "opened";
    this.loading = true;

    await this.loadMatchProblemsGroupProducts();
  }

  async loadMatchProblemsGroupProducts() {
    this.loading = true;

    const matchedProductOnTopFunc = (
      a: MatchProblemProduct,
      b: MatchProblemProduct
    ) => (a.matched === b.matched ? 0 : a.matched ? -1 : 1);

    try {
      this.matchProblemProducts = await this.getMatchProblemsGroupProducts(
        AgentsMatchProblemGroupMixinTags.GetMatchProblemsGroupProducts,
        this.profile.slug,
        {
          adcontrol_product_id: this.adcontrolProductId as number,
        }
      ).then((results) => results.sort(matchedProductOnTopFunc));

      this.options = this.matchProblemProducts.map((product) => {
        return {
          id: product.id,
          text: product.id,
        };
      });
    } catch (error) {
      ToastInvoker.errorToast(
        "Errore durante il caricamento dei prodotti.",
        error
      );
    } finally {
      this.loading = false;
    }
  }

  async onSave() {
    if (!this.selectedProductId) {
      ToastInvoker.errorToast("Seleziona un prodotto prima di salvare.", null);
      return;
    }
    this.loading = true;
    try {
      await this.resolveMatchProblemGroup(
        AgentsMatchProblemGroupMixinTags.ResolveMatchProblemGroup,
        this.profile?.slug || "",
        this.adcontrolProductId,
        this.selectedProductId as string,
        this.selectedCompanyId?.toString() as string
      );
      ToastInvoker.successToast(`Capofila scelto: ${this.selectedProductId}`);
      this.resolved = true;
      this.reloadNotificationForGroup(NotificationBadgeGroups.MatchProblem);
    } catch (error) {
      ToastInvoker.errorToast("Errore durante il salvataggio.", error);
    } finally {
      this.loading = false;
    }
  }

  areMultipleProductsSolved() {
    return !this.multipleProductsPresent;
  }

  areMultipleProductsPresent() {
    return this.multipleProductsPresent;
  }

  onMultipleProductsPresence(value: boolean) {
    this.multipleProductsPresent = value;
  }

  isResolved() {
    return this.resolved;
  }

  hideWhenResolved() {
    return this.isResolved() ? "group-resolved" : "";
  }

  resolvedTitle() {
    return this.isResolved() ? "text-muted" : "";
  }

  get adcontrolCompanyIconColor(): string {
    return this.matchProblemGroup.adcontrolCompanyIconColor;
  }
}
